import BangXepHangFifa from "@/components/BangXepHangFifa";

/** BXH FIFA Nam — type=1. `data-league` = continent slug (optional). */
export default function BangXepHangFifaNam({ league: continent }) {
  return <BangXepHangFifa type={1} continent={continent || ""} />;
}
